<div class="row">
    <div class="col">
        <h1 class="h1-responsive" *ngIf="loadedClient"><i class="fa fa-user p-2"></i>{{client.getDisplayString()}} <span class="pl-2 h3"><dac-copy-clipboard [iconClass]="'fa-share-alt-square'" [content]="clientShareLink"></dac-copy-clipboard></span></h1>
    </div>
    <div class="x-float-right">
        <p><a class="btn btn-primary" [routerLink]="['../client']">Back</a></p>
    </div>
</div>
<div class="row" *ngIf="!loadedClient">
    <div class="col">
        <p class="alert alert-warning">
            <app-spin-icon></app-spin-icon>Loading Client...
        </p>
    </div>
</div>
<div class="row" *ngIf="loadedClient">
    <mdb-tabset #staticTabs [buttonClass]="'nav-tabs tabs-3 primary-color'" [contentClass]="'card'" class="col-12">
        <mdb-tab heading="Assignment Reports" class="p-3 reportsTab">
            <div class="alert alert-warning" *ngIf="assignments.length <= 0">No assessments currently assigned.</div>
            <div class="row list-item-group view view-cascade secondary-gradient p-3 text-light" *ngIf="assignments.length > 0">
                <div class="col-12">
                    <div class="row"> 
                        <div class="col-6">Name</div>
                        <div class="col-2">Assigned</div>
                        <div class="col-2">Completed</div>
                        <div class="col-2 text-center">Action</div>
                    </div>
                </div>
            </div>
            <div class="row list-group-item" *ngFor="let assignment of assignments">
                <div class="col-12" *ngIf="assignment.type == 'Assessment'"> 
                    <div class="row">
                        <div class="col-6">
                            <i class="fa fa-clipboard"></i>
                            {{assignment.Name}}
                        </div>
                        <div class="col-2">{{assignment.DateAssigned|date:'mediumDate'}}</div>
                        <div class="col-2">
                            <span *ngIf="assignment.IsComplete">{{assignment.DateCompleted|date:'mediumDate'}}</span>
                            <span *ngIf="!assignment.IsComplete">Incomplete</span>
                        </div>
                        <div class="col-2 text-center">
                            <button class='btn btn-primary btn-sm' *ngIf="assignment.IsComplete" [routerLink]="['result', assignment.ResultId]">
                                View Report
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12" *ngIf="assignment.type == 'LibraryAsset'"> 
                    <div class="row">
                        <div class="col-6">
                            <i class="fa fa-file-text"></i>
                            {{assignment.Name}}
                        </div>
                        <div class="col-2">{{assignment.DateAssigned|date:'mediumDate'}}</div>
                        <div class="col-2">
                            <span *ngIf="assignment.IsComplete">{{assignment.DateCompleted|date:'mediumDate'}}</span>
                            <span *ngIf="!assignment.IsComplete">Incomplete</span>
                        </div>
                        <div class="col-2 text-center">
                            <button class='btn btn-primary btn-sm' *ngIf="assignment.IsComplete" [routerLink]="['asset-result', assignment.ResultId]">
                                View Report
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12" *ngIf="assignment.type == 'AssessmentGroup'">
                    <div class="row mb-2">
                        <div class="col-6">
                            <i class="fa fa-folder"></i>
                            {{assignment.Name}}
                        </div>
                        <div class="col-2">{{assignment.DateAssigned|date:'mediumDate'}}</div>
                        <div class="col-2">
                            <span *ngIf="assignment.IsComplete">{{assignment.DateCompleted|date:'mediumDate'}}</span>
                            <span *ngIf="!assignment.IsComplete">Incomplete - {{assignment.getAssignmentsCompleted()}}/{{assignment.getTotalAssignments()}}</span>
                        </div>
                        <div class="col-2">
                        </div>
                    </div>
                    <div class="row">
                            <div class="col-6 pl-5">
                                <h6>Battery Reports</h6>
                                <hr />
                            </div>
                        </div>
                    <!--Need to display the battery reports underneath here...-->
                    <div class="row" *ngFor="let report of getReportsForAssignment(assignment)">
                            <div class="col-6 pl-5">
                                <i class="fa fa-bar-chart"></i>
                                {{report.name}}
                            </div>
                            <div class="col-2 text-center"></div>
                            <div class="col-2">
                                <span *ngIf="assignment.IsComplete">{{assignment.DateCompleted|date:'mediumDate'}}</span>
                                <span *ngIf="!assignment.IsComplete">Incomplete</span>
                            </div>
                            <div class="col-2  text-center">
                                <button class='btn btn-primary btn-sm' *ngIf="assignment.IsComplete" [routerLink]="['report', report.id, assignment.id]">
                                    View Report
                                </button>
                            </div>
                    </div>
                    <div class="row">
                        <div class="col-6 pl-5 mt-3">
                            <h6>Individual Assessment Reports</h6>
                            <hr />
                        </div>
                    </div>
                    <div class="row" *ngFor="let item of assignment.Items">
                            <div class="col-6 pl-5">
                                <i class="fa fa-bar-chart"></i>
                                {{item.Name}}
                            </div>
                            <div class="col-2"></div>
                            <div class="col-2">
                                <span *ngIf="item.IsComplete">{{item.DateCompleted|date:'mediumDate'}}</span>
                                <span *ngIf="!item.IsComplete">Incomplete</span>
                            </div>
                            <div class="col-2 text-center">
                                <button class='btn btn-primary btn-sm' *ngIf="item.IsComplete" [routerLink]="['result', item.ResultId]">
                                    View Report
                                </button>
                            </div>
                    </div>
                </div>
            </div>
        </mdb-tab>
        <mdb-tab heading="Manage Assignments">
            <dac-client-manage-assignments class="col" [client]="client" *ngIf="hasActiveSubscription"></dac-client-manage-assignments>
            <dac-user-upgrade-subscription-notice *ngIf="!hasActiveSubscription"></dac-user-upgrade-subscription-notice>
        </mdb-tab>
        <mdb-tab heading="Send Invitation">
            <dac-client-send-invitation class="col" [client]="client" *ngIf="hasActiveSubscription"></dac-client-send-invitation>
            <dac-user-upgrade-subscription-notice *ngIf="!hasActiveSubscription"></dac-user-upgrade-subscription-notice>
        </mdb-tab>
        <mdb-tab heading="Admin">
            <div class="col">
                <h2>Client Information</h2>
                <hr class="mb-3" />
                <div class="row">
                    <label class="col-md-4 col-lg-3" for="uniqueToken">
                        <h6><i class="fa fa-key pt-2 pr-2 h4-responsive"></i>Client Login Identifier:</h6>
                    </label>
                    <div class="col-6 col-md-8 col-lg-9">
                        {{client.customField1}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-lg-3">
                        <h6><i class="fa fa-user red-text pt-2 pr-2 h4-responsive"></i>Assigned User:</h6>
                    </div>
                    <div class="col-6 col-md-8 col-lg-9">
                        {{client.user?.getDisplayName()}}
                    </div>
                </div>
                
                <h2 class="mt-5">Update Client Information</h2>
                <hr class="mb-3" />
                <form #clientForm="ngForm" class="form-horizontal">
                    <div class="form-group">
                        <label class="col-12" for="firstName">
                            <h6><i class="fa fa-user pt-2 pr-2 h4-responsive"></i>First Name*:</h6>
                            
                        </label>
                        <div class="col-12">
                            <input class="form-control" name="firstName" type="text" [(ngModel)]="clientToSave.firstName" 
                            required #firstName="ngModel" />
                        </div>
                        <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched || clientForm.submitted)"
                            class="alert alert-danger">
                            <div *ngIf="firstName.errors.required">
                                First Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-12" for="lastName">
                            <h6><i class="fa fa-user pt-2 pr-2 h4-responsive"></i>Last Name*:</h6>
                            
                        </label>
                        <div class="col-12">
                            <input class="form-control" name="lastName" type="text" [(ngModel)]="clientToSave.lastName" required #lastName="ngModel" />
                        </div>
                        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched || clientForm.submitted)"
                            class="alert alert-danger">
                            <div *ngIf="lastName.errors.required">
                                Last Name is required.
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-12" for="emailAddress">
                            <h6><i class="fa fa-envelope pt-2 pr-2 h4-responsive"></i>Email*:</h6>
                        </label>
                        <div class="col-12">
                            <input class="form-control" name="emailAddress" type="text" email [(ngModel)]="clientToSave.email" #emailAddress="ngModel" />
                        </div>
                        <div *ngIf="emailAddress.invalid && (emailAddress.dirty || emailAddress.touched || clientForm.submitted)"
                            class="alert alert-danger">
                            <div *ngIf="emailAddress.errors.required">
                                Email is required.
                            </div>
                            <div *ngIf="emailAddress.errors.email">
                                    Email must be a valid email address with the local address being shorter than 64 characters and the whole email
                                    address less than 254 characters.
                                </div>
                        </div>
                    </div>
                    
                    <div class="form-group" *hasPermission="'Admin'">
                        <label class="col-12" for="assignedUser"><h6><i class="fa fa-user red-text pt-2 pr-2 h4-responsive"></i>Assigned User</h6></label>
                        <div class="col-12">
                            <user-selector [user]="clientToSave.user" [allowEmpty]="true" (selected)="setNewUser($event)"></user-selector>
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <div class="col">
                            <input [disabled]="isSaving || !hasActiveSubscription" class="btn btn-primary" type="button" value="Save" (click)="clientForm.submitted=true;updateClientUser(clientForm.valid)" />
                            <dac-user-upgrade-subscription-notice *ngIf="!hasActiveSubscription"></dac-user-upgrade-subscription-notice>
                        </div>
                    </div>
                </form>
            </div>
        </mdb-tab>
    </mdb-tabset>
</div>




// WEBPACK FOOTER //
// ./src/app/admin/client-edit/client-edit.component.html